<template>
  <div>
    <v-row>
      <v-col cols='12'>
        <v-text-field
          prepend-icon='mdi-email'
          label='Email'
          :rules='[rules.email, rules.required]'
          v-model='value.email'
        ></v-text-field>
      </v-col>
      <v-col cols='12' md='6'>
        <v-text-field
          prepend-icon='mdi-phone'
          label='Home phone'
          v-model='value.home_phone'
        ></v-text-field>
      </v-col>
      <v-col cols='12' md='6'>
        <v-text-field
          prepend-icon='mdi-cellphone'
          label='Cell phone'
          v-model='value.cell_phone'
        ></v-text-field>
      </v-col>
      <v-col cols='12' md='6'>
        <v-text-field
          label='Address'
          v-model='value.address'
        ></v-text-field>
      </v-col>
      <v-col cols='12' md='6'>
        <v-text-field
          label='City'
          v-model='value.city'
        ></v-text-field>
      </v-col>
      <v-col cols='12' md='3'>
        <v-text-field
          label='Province'
          v-model='value.province'
        ></v-text-field>
      </v-col>
      <v-col cols='12' md='6'>
        <v-text-field
          label='Country'
          v-model='value.country'
        ></v-text-field>
      </v-col>
      <v-col cols='12' md='3'>
        <wc-postal-code-input
          v-model='value.postal'
        ></wc-postal-code-input>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import formRules from '@/mixins/formRules'
import WCPostalCodeInput from '@/components/forms/WCPostalCodeInput'

export default {
  name: 'profile-details-form',
  mixins: [formRules],
  props: {
    value: {
      required: true
    }
  },
  components: {
    'wc-postal-code-input': WCPostalCodeInput
  }
}
</script>
